(() => {
  "use strict";

  const FULL_SRC = document.currentScript && document.currentScript.src
    ? document.currentScript.src.replace(/cloud9-concierge-loader\.js(?:\?.*)?$/, "cloud9-concierge.js?v=2026052904")
    : "https://www.cloud9smokeco.com/cdn/shop/t/28/assets/cloud9-concierge.js?v=2026052904";
  const LOADER_ID = "cloud9-concierge-loader";
  const STYLE_ID = "cloud9-concierge-loader-styles";
  const BLOCKED_PATHS = ["/checkout", "/cart"];

  function removeExposedWtText() {
    if (!document.body) return;
    const exposedCommentText = ["//WT", "form", "listener"].join(" ");
    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    const matches = [];
    let node = walker.nextNode();
    while (node) {
      if (node.nodeValue && node.nodeValue.trim() === exposedCommentText) matches.push(node);
      node = walker.nextNode();
    }
    matches.forEach((textNode) => textNode.remove());
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", removeExposedWtText, { once: true });
  else removeExposedWtText();

  if (window.Cloud9ConciergeLoaded || document.getElementById("cloud9-concierge") || document.getElementById(LOADER_ID)) return;
  if (BLOCKED_PATHS.some((path) => window.location.pathname.startsWith(path))) return;

  function ageGateVisible() {
    const gate = document.getElementById("age-verification");
    if (!gate) return false;
    const style = window.getComputedStyle(gate);
    const rect = gate.getBoundingClientRect();
    return style.display !== "none" && style.visibility !== "hidden" && style.opacity !== "0" && rect.width > 0 && rect.height > 0;
  }

  function waitForAgeGate(callback) {
    if (window.Cloud9ConciergeAgeGateWait) return;
    window.Cloud9ConciergeAgeGateWait = true;
    let observer;
    const tryStart = () => {
      if (ageGateVisible()) return;
      if (observer) observer.disconnect();
      window.Cloud9ConciergeAgeGateWait = false;
      callback();
    };
    observer = new MutationObserver(tryStart);
    observer.observe(document.documentElement, { attributes: true, childList: true, subtree: true });
    window.setTimeout(tryStart, 250);
  }

  function removeLoaderShell() {
    const loader = document.getElementById(LOADER_ID);
    if (loader) loader.remove();
  }

  function setWidgetHidden(hidden) {
    const widget = document.getElementById("cloud9-concierge");
    if (widget) widget.style.display = hidden ? "none" : "";
  }

  function syncAgeGateState() {
    if (ageGateVisible()) {
      removeLoaderShell();
      setWidgetHidden(true);
      return;
    }
    setWidgetHidden(false);
    init();
  }

  function watchAgeGate() {
    if (window.Cloud9ConciergeAgeGateSync) return;
    window.Cloud9ConciergeAgeGateSync = true;
    new MutationObserver(syncAgeGateState).observe(document.documentElement, { attributes: true, childList: true, subtree: true });
    window.setInterval(syncAgeGateState, 750);
  }

  function createEl(tag, attrs = {}, html = "") {
    const el = document.createElement(tag);
    Object.entries(attrs).forEach(([key, value]) => {
      if (key === "class") el.className = value;
      else if (key === "text") el.textContent = value;
      else el.setAttribute(key, value);
    });
    if (html) el.innerHTML = html;
    return el;
  }

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;
    document.head.appendChild(createEl("style", { id: STYLE_ID }, `
      #${LOADER_ID} { position: relative; z-index: 2147481999; font-family: var(--font-body-family, Inter, Arial, sans-serif); }
      .c9l-toggle { position: fixed; right: 22px; bottom: 22px; min-width: 142px; height: 48px; border: 1px solid rgba(14, 174, 239, .36); border-radius: 999px; background: #050505; color: #fff; display: inline-flex; align-items: center; justify-content: center; gap: 9px; box-shadow: 0 12px 30px rgba(0, 0, 0, .24); font-weight: 700; cursor: pointer; padding: 0 18px; }
      .c9l-toggle:focus-visible { outline: 3px solid rgba(14, 174, 239, .32); outline-offset: 2px; }
      .c9l-dot { width: 9px; height: 9px; border-radius: 50%; background: #0eaeef; box-shadow: 0 0 0 4px rgba(14, 174, 239, .22); }
      @media (max-width: 640px) { .c9l-toggle { right: 12px; bottom: 12px; min-width: 122px; height: 44px; padding: 0 14px; } }
    `));
  }

  function openFullWidgetWhenReady() {
    const started = Date.now();
    const open = () => {
      const toggle = document.querySelector(".c9c-toggle");
      if (toggle) {
        const loader = document.getElementById(LOADER_ID);
        if (loader) loader.remove();
        toggle.click();
        return;
      }
      if (Date.now() - started < 3500) window.setTimeout(open, 50);
    };
    open();
  }

  function loadFullWidget(openAfterLoad = false) {
    if (openAfterLoad) window.Cloud9ConciergeOpenAfterLoad = true;
    if (window.Cloud9ConciergeLoaded) {
      if (openAfterLoad) openFullWidgetWhenReady();
      return;
    }
    if (window.Cloud9ConciergeLoading) return;
    window.Cloud9ConciergeLoading = true;
    const existing = document.querySelector(`script[src="${FULL_SRC}"]`);
    const script = existing || createEl("script", { src: FULL_SRC, defer: "defer", "data-cloud9-ai": "2026-05-29-learning" });
    if ("fetchPriority" in script) script.fetchPriority = "low";
    script.addEventListener("load", () => {
      window.Cloud9ConciergeLoading = false;
      if (openAfterLoad || window.Cloud9ConciergeOpenAfterLoad) openFullWidgetWhenReady();
    }, { once: true });
    script.addEventListener("error", () => {
      window.Cloud9ConciergeLoading = false;
      const button = document.querySelector(".c9l-toggle span:last-child");
      if (button) button.textContent = "Chat unavailable";
    }, { once: true });
    if (!existing) document.head.appendChild(script);
  }

  function init() {
    if (document.getElementById(LOADER_ID) || window.Cloud9ConciergeLoaded || document.getElementById("cloud9-concierge")) return;
    injectStyles();
    const root = createEl("section", { id: LOADER_ID, "aria-label": "Cloud 9 Smoke Co. chat launcher" });
    const button = createEl("button", { class: "c9l-toggle", type: "button", "aria-label": "Chat with Cloud 9 Smoke Co." }, '<span class="c9l-dot" aria-hidden="true"></span><span>Chat with Cloud 9</span>');
    button.addEventListener("mouseenter", () => loadFullWidget(false), { once: true });
    button.addEventListener("focus", () => loadFullWidget(false), { once: true });
    button.addEventListener("touchstart", () => loadFullWidget(false), { once: true, passive: true });
    button.addEventListener("click", () => {
      const label = button.querySelector("span:last-child");
      if (label) label.textContent = "Opening...";
      loadFullWidget(true);
    });
    root.appendChild(button);
    document.body.appendChild(root);
  }

  function boot() {
    watchAgeGate();
    window.setTimeout(syncAgeGateState, 700);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
